export * from './svg-icon.component';
export * from './svg-icon.providers';
